<template>
  <v-chip :style="styleChip()" x-small dark>{{ pedido.descstatus }}</v-chip>
</template>

<script>
export default {
  props: {
    pedido: Object,
  },
  methods: {
    styleChip() {
      return `background-color: ${this.pedido.coresstatus}`;
    },
  },
};
</script>

<style>
</style>